import isEqual from "lodash/isEqual";

export function sameSettingsValue(left: unknown, right: unknown): boolean {
  const leftJson = JSON.stringify(left);
  const rightJson = JSON.stringify(right);
  return (
    leftJson === rightJson ||
    (leftJson !== undefined &&
      rightJson !== undefined &&
      isEqual(JSON.parse(leftJson), JSON.parse(rightJson)))
  );
}

/** Fields of `next` that differ from `initial`, keyed by settings group. */
export function groupedSettingsChanges<
  T extends Partial<Record<string, Record<string, unknown>>>,
>(initial: T, next: T): Record<string, Record<string, unknown>> {
  const changes: Record<string, Record<string, unknown>> = {};
  for (const group of Object.keys(next)) {
    const initialGroup: Record<string, unknown> = initial[group] ?? {};
    const nextGroup: Record<string, unknown> = next[group] ?? {};
    for (const [field, value] of Object.entries(nextGroup)) {
      if (!sameSettingsValue(initialGroup[field], value)) {
        changes[group] = { ...changes[group], [field]: value };
      }
    }
  }
  return changes;
}

/** Drops paths the baseline patch (built from stored settings) already writes identically. */
export function changedTeamPatchPaths(
  baseline: { set: Record<string, unknown>; unset: string[] },
  requested: { set: Record<string, unknown>; unset: string[] },
): { set: Record<string, unknown>; unset: string[] } {
  return {
    set: Object.fromEntries(
      Object.entries(requested.set).filter(
        ([path, value]) =>
          !(path in baseline.set) ||
          !sameSettingsValue(baseline.set[path], value),
      ),
    ),
    unset: requested.unset.filter((path) => !baseline.unset.includes(path)),
  };
}
